import Icon from '../../../components/AppIcon';

const AnalyticsCard = ({ icon, title, value, change, changeType }) => {
  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  return (
    <div className="bg-card rounded-lg p-6 border border-border shadow-card">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name={icon} size={24} color="var(--color-primary)" />
          </div>
          <div>
            <p className="text-sm text-muted-foreground">{title}</p>
            <p className="text-2xl font-bold text-foreground mt-1">{value}</p>
          </div>
        </div>
      </div>
      {change && (
        <div className="flex items-center gap-2">
          <Icon 
            name={changeType === 'positive' ? 'TrendingUp' : 'TrendingDown'} 
            size={16} 
            className={getChangeColor()}
          />
          <span className={`text-sm font-medium ${getChangeColor()}`}>
            {change}
          </span>
          <span className="text-sm text-muted-foreground">vs mes anterior</span>
        </div>
      )}
    </div>
  );
};

export default AnalyticsCard;